import React, { useEffect, useRef, useState }  from 'react';
import styled from 'styled-components';
import { IconChevronBulk } from '../../Assets/panels/IconChevronBulk';
const Styles = styled.div`
  margin: 2rem 0 0.5rem;
  .grid-questions {
    width: calc(100% - calc(var(--universal-pad) * 2));
    margin: 0 var(--universal-pad);
    display: grid;
    grid-template-columns: repeat(1);
    gap: 1rem;
    &.class-2 {
      grid-template-columns: repeat(2, calc(50% - 0.5rem));
    }
    .questions {
      display: flex;
      flex-direction: column;
      background-color: var(--n-grey-0);
      box-shadow: 0px 4px 50px -16px #00000028;
      border-radius: var(--border-radius-32);
      overflow: hidden;
      transition: var(--trans-2);
      max-height: 500px;
      &.closed {
        max-height: 60px;
        .title {
          .icon {
            svg {
              transform: rotate(180deg);
            }
          }
        }
      }
      .title {
        padding: 0 2rem;
        font-size: 1.25rem;
        font-weight: 700;
        background-color: var(--n-grey-0);
        border-radius: var(--border-radius-32);
        border: 1px solid #E5E5E5;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        gap: 1rem;
        .title-text {
          font-size: 1.1rem;
          padding: 1rem 0;
        }
        .icon {
          svg {
            fill: var(--n-grey-2);
            display: block;
            transition: var(--trans-2);
          }
        }
      }
      .text {
        padding: 0.5rem 2rem 1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 0.5rem;
        white-space: pre-wrap;
      }
    }
  }
  @media screen and (max-width: 850px) {
    .grid-questions {
      grid-template-columns: repeat(1, calc(100%));
      &.class-2 {
        grid-template-columns: repeat(1, calc(100%));
      }
      .questions{
        .title {
          font-size: 1rem;
        }
      }
    }
  }
`
export default function FaqSmall24 (props){
  const {data: dataRaw} = props;
  const data = JSON.parse(dataRaw);
  const [closed, setClosed] = useState({});
  const [opened, setOpened] = useState({});
  
  const getModelOpened = () => {
    if(data.model === "2" || data.model === "4"){
      return false;
    }
    return true;
  }
  const getModelClass = () => {
    if(data.model === "3" || data.model === "4"){
      return "class-2";
    }
    return "";
  }
  const makeQuestions = () => {
    return data.questions.map((v, i) => {
      let closedItem = (closed[i] !== undefined) ? closed[i] : getModelOpened();
      return (
        <OneFaqItem 
          v={v} 
          i={i} 
          key={i} 
          closedItem={closedItem} 
          getModelOpened={getModelOpened}
          setClosed={setClosed}
        />)
    })
  }
  return (
    <Styles>
      <div className={'grid-questions ' + getModelClass()}>
        {makeQuestions()}
      </div>
    </Styles>
  )
}



const OneFaqItem = ({v, i, closedItem, getModelOpened, setClosed}) => {
  const [heights, setHeights] = useState(28);
  const ref = useRef();
  useEffect(() => {
    if(ref.current){
      let sizes = ref.current.getBoundingClientRect();
      setHeights(sizes.height + 2)
    }
  }, [])
  useEffect(() => {
    if(ref.current){
      let sizes = ref.current.getBoundingClientRect();
      setHeights(sizes.height + 2)
    }
  }, [ref.current])
  return (
    <div 
      className={'questions' + ((closedItem) ? " closed" : "")}
      style={{maxHeight: ((closedItem) ? (heights) + "px" : "")}}
      key={i}
    >
      <div className='title' onClick={() => {
        setClosed((prev) => {
          let temp = {...prev}
          if(temp[i] === undefined){
            temp[i] = getModelOpened();
          }
          temp[i] = (!temp[i])
          return temp;
        })
      }}>
        <h2 className='title-text' ref={ref}>
          {v.title}
        </h2>
        <div className={'icon'}>
          <IconChevronBulk/>
        </div>
      </div>
      <pre className='text' dangerouslySetInnerHTML={{__html: v.text}}>
      </pre>
    </div>
  )
}

